module.exports = __webpack_public_path__ + "img/42_51.a1f07500.png";